<div class="language-root">
  <!-- Mobile version -->
  <div class="language-root__mobile">
    <ng-container>
      <div class="language-selector">
        <div class="v-one-language__link">
          <button
            class="v-one-language__link-button language-selector__trigger"
          >
            <span class="language-selector__content">
              <v-one-icon
                [name]="'language'"
                [type]="ICON_TYPE.OUTLINE"
                className="language-icon"
              >
              </v-one-icon>
              <span class="language-selector__label">{{
                'Language' | translate
              }}</span>
            </span>
          </button>

          @if (languages.length > 0) {
            <button
              class="v-one-language__chevron-button"
              (click)="expandedChild()"
            >
              <div
                class="v-one-language__chevron"
                [class.v-one-language__chevron--rotate]="isCollapsed()"
              >
                <v-one-icon
                  name="chevronDown"
                  [type]="ICON_TYPE.OUTLINE"
                  color="white"
                  className="chevronDown"
                >
                </v-one-icon>
              </div>
            </button>
          }
        </div>
        @if (isCollapsed() && languages.length > 0) {
          <ul class="v-one-language__submenu">
            @for (language of languages; track language) {
              <li class="v-one-language__subitem">
                <button
                  class="v-one-language__sublink"
                  [class.v-one-language__sublink--active]="
                    language.code === languageCurrent()
                  "
                  (click)="changeLang(language.code)"
                >
                  <span class="v-one-language__dot"></span>
                  <span>
                    <img
                      [src]="languageIcon(language.code)"
                      width="18"
                      height="13"
                      alt="flag"
                    />
                  </span>
                  <span class="v-one-language__label">
                    {{ language.label | translate }}
                  </span>
                </button>
              </li>
            }
          </ul>
        }
        <button
          class="v-one-language__link-button v-one-language__link-button--logout"
          (click)="logout()"
        >
          {{ 'Log out' | translate }}
        </button>
      </div>
    </ng-container>
  </div>

  <!-- Desktop version -->
  <div class="language-root__desktop">
    <ng-container>
      <div class="person-selector-wrapper">
        <div
          class="person-selector"
          [class.person-selector--desktop]="isCollapsed()"
        >
          <button class="person-selector__trigger">
            <v-one-icon name="user" [type]="ICON_TYPE.FILLED"> </v-one-icon>
          </button>
          @if (languages.length > 0) {
            <button
              class="v-one-chevron-desktop"
              (click)="expandedChild($event)"
            >
              <div
                class="v-one-chevron"
                [class.v-one-chevron--rotate]="isCollapsed()"
              >
                <v-one-icon name="chevronDown" [type]="ICON_TYPE.OUTLINE">
                </v-one-icon>
              </div>
            </button>
          }
        </div>
        @if (isCollapsed()) {
          <div
            class="overlay"
            role="button"
            tabindex="0"
            (click)="closeMenu()"
            (keydown.enter)="closeMenu()"
            (keydown.space)="closeMenu()"
          ></div>
          <div
            class="v-one-container-menu"
            role="button"
            tabindex="0"
            (click)="$event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation()"
          >
            <span class="v-one-container-menu__label">{{
              'Language' | translate
            }}</span>
            <ul class="v-one-container-menu__list">
              @for (language of languages; track language) {
                <li>
                  <button
                    class="v-one-container-menu__button-language"
                    (click)="changeLang(language.code)"
                    [class.v-one-container-menu--active]="
                      language.code === languageCurrent()
                    "
                  >
                    <span>
                      <img
                        [src]="languageIcon(language.code)"
                        width="18"
                        height="13"
                        alt="flag"
                      />
                    </span>
                    <span>{{ language.label | translate }}</span>
                  </button>
                </li>
              }
            </ul>
            <button
              class="v-one-container-menu__button-logout"
              (click)="logout()"
            >
              {{ 'Log out' | translate }}
            </button>
          </div>
        }
      </div>
    </ng-container>
  </div>
</div>
